import React, { Component } from 'react';
import Immutable from 'immutable';
import PropTypes from 'prop-types';
import {
  cellsToString,
  sendReport,
} from 'reducers/async';

import styles from './style';

export default class ReportError extends Component {
  static propTypes = {
    // state props
    canSendReport: PropTypes.bool.isRequired,
    cells: PropTypes.oneOfType([
      PropTypes.instanceOf(Immutable.List),
      PropTypes.instanceOf(Array),
    ]).isRequired,
    isReportingError: PropTypes.bool.isRequired,
    minefield: PropTypes.oneOfType([
      PropTypes.instanceOf(Immutable.Map),
      PropTypes.instanceOf(Map),
    ]).isRequired,
    // dispatch props
    highlight: PropTypes.func.isRequired,
    reportErrorStart: PropTypes.func.isRequired,
    reportErrorEnd: PropTypes.func.isRequired,
    reportErrorTimeout: PropTypes.func.isRequired,
    reportErrorToggle: PropTypes.func.isRequired,
  }

  /* local state */
  state = {
    cells: '',
    description: '',
    email: '',
  }


  /* lifecycle handlers */

  componentWillReceiveProps(nextProps) {
    if (nextProps.cells !== this.props.cells) {
      this.setState({ cells: cellsToString(nextProps.cells) });
    }
  }

  /* event handlers */

  toggleReportWindow = () => {
    if (!this.props.isReportingError) {
      this.props.highlight(this.props.cells);
    } else {
      this.setState({ description: '' });
      this.setState({ email: '' });
    }
    document.getElementById('btnSubmit').disabled = true;
    this.props.reportErrorToggle(!this.props.isReportingError);
  }

  submitClickHandler = () => {
    this.props.reportErrorToggle(!this.props.isReportingError);
    this.props.reportErrorStart();
    sendReport(this.props.minefield, this.state.description, this.state.cells, this.state.email)
    .then(res => this.props.reportErrorEnd(res))
    .catch(error => this.props.reportErrorEnd(error));
    this.setState({ description: '' });
    this.setState({ email: '' });
    setTimeout(this.props.reportErrorTimeout, 15000);
  }

  descriptionOnChangeHandler = event => {
    this.setState({ description: event.target.value }, () => {
      this.enableSubmit();
    });
  }

  emailOnChangeHandler = event => {
    this.setState({ email: event.target.value });
  }

  enableSubmit = () => {
    const btnSubmit = document.getElementById('btnSubmit');
    if (this.state.description !== '' && this.state.cells !== '') {
      btnSubmit.disabled = false;
    } else {
      btnSubmit.disabled = true;
    }
  }

  render() {
    return (
      <div>
        <button className={styles['report_button']}
          disabled={!this.props.canSendReport}
          onClick={this.toggleReportWindow}
        >
          Report Error
        </button>
        <div id="errorReportForm"
          className={styles['error_form']}
          style={{ display: this.props.isReportingError ? 'grid' : 'none' }}
        >
          <h1>Error Report Form</h1>

          <div className={styles['button_grid']}>
            <button className={styles['cancel_button']} onClick={this.toggleReportWindow}>Cancel</button>
            <button id="btnSubmit"
              className={styles['submit_button']}
              onClick={this.submitClickHandler}
            >Submit</button>
          </div>

          <div className={styles['column_1']}>
            <label htmlFor="email">Insert email (optional):</label><br />
            <input
              type="email"
              id="email"
              onChange={this.emailOnChangeHandler}
              value={this.state.email}
            /><br />
            <label htmlFor="cellSelection">Click on affected cells (puzzle will be included in mail):</label><br />
            <textarea readOnly
              id="cellSelection"
              className={styles['short_text_area']}
              placeholder="Select the affected cells by clicking on them in the board"
              value={this.state.cells}
            />
          </div>
          <div className={styles['column_2']}>
            <label htmlFor="description">Describe the issue:</label><br />
            <textarea id="description"
              className={styles['long_text_area']}
              onChange={this.descriptionOnChangeHandler}
              value={this.state.description}
            />
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/general_panel/ReportError.jsx